import React from 'react';

export const revisionStatus = {
  awaiting_contractor: 'Waiting for contractor reconfirmation',
  awaiting_client: 'Waiting for client quote approval',
  applied: 'Published and in effect',
  declined: 'Contractor requested different changes',
  withdrawn: 'Withdrawn by client',
  superseded: 'Replaced by a newer revision',
};
function display(value, field) {
  if (value == null || value === '' || (Array.isArray(value) && !value.length)) return 'Not set';
  if (['starts_at', 'ends_at', 'meet_at'].includes(field)) return new Date(value).toLocaleString();
  if (Array.isArray(value)) return value.map(v => typeof v === 'object' ? [v.display_name, v.role_label, v.phone, v.email].filter(Boolean).join(' · ') : String(v).replaceAll('_', ' ')).join('; ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value).replaceAll('_', ' ');
}
export function ProjectChangeSummary({ revision }) {
  if (!revision) return null;
  return <div className="space-y-3">
    <p className="font-semibold">Project revision {revision.version} · {revisionStatus[revision.state] || revision.state}</p>
    {revision.reason && <p className="text-sm whitespace-pre-line">{revision.reason}</p>}
    {revision.response_note && <p className="text-sm whitespace-pre-line">Contractor response: {revision.response_note}</p>}
    <dl className="space-y-3 text-sm">{revision.changes?.map(change => <div key={change.field} className="border-t pt-2">
      <dt className="font-medium">{change.label}</dt>
      <dd className="grid gap-2 sm:grid-cols-2 mt-1 break-words whitespace-pre-line"><span className="text-[var(--avcp-ink-soft)]">Before: {display(change.before, change.field)}</span><span>Proposed: {display(change.after, change.field)}</span></dd>
    </div>)}</dl>
  </div>;
}
